import { Component, EventEmitter, Output } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'oc-countdown',
  standalone: true,
  imports: [CommonModule],
  template: ` <div class="oc-countdown">{{ count }}</div>`,
  styles: `
    .oc-countdown {
      width: 140px;
      height: 140px;
      background-color: #bbb;
      line-height: 140px;
      text-align: center;
      font-size: 5.5rem;
      font-weight: bold;
      color: white;
      border-radius: 999px;
    }
  `,
})
export class CountdownComponent {
  @Output() completed: EventEmitter<null> = new EventEmitter();

  public count = 3;

  private intervalTimer: any;

  constructor() {
    this.intervalTimer = setInterval(() => {
      if (this.count > 0) {
        this.count--;
      } else if (this.count === 0) {
        this.completed.next(null);
      }
    }, 1000);
  }
}
